export const DEFAULT_ARMENIA_BBOX = '43.449928,38.794567~46.634583,41.301834';

export const getYandexLangCode = (lang) => {
	const map = { hy: 'hy_AM', en: 'en_US', ru: 'ru_RU' };
	return map[lang] || 'hy_AM';
};

export function getAddressComponents(geoObj) {
	const components = geoObj?.metaDataProperty?.GeocoderMetaData?.Address?.Components || [];
	const get = (...kinds) => components.find((component) => kinds.includes(component.kind))?.name || '';

	return {
		country: get('country'),
		province: get('province'),
		area: get('area'),
		locality: get('locality'),
		district: get('district'),
		street: get('street'),
		house: get('house'),
	};
}

export function getLocationName(geoObj) {
	const { locality, area, district, province } = getAddressComponents(geoObj);
	const parts = [locality, area, district, province].filter(Boolean);

	return [...new Set(parts)][0] || '';
}

export function buildAddressFromGeocode(geoObj) {
	const formatted = geoObj?.metaDataProperty?.GeocoderMetaData?.Address?.formatted_address;
	if (formatted) {
		return formatted;
	}

	const { street, house } = getAddressComponents(geoObj);
	const locationName = getLocationName(geoObj);
	const streetLine = [street, house].filter(Boolean).join(', ');

	if (streetLine && locationName) {
		return `${streetLine}, ${locationName}`;
	}

	return streetLine || locationName;
}

export function formatAddressLabel(addr) {
	if (!addr) return '';

	if (typeof addr === 'string') {
		return addr;
	}

	if (addr.address) {
		return addr.address;
	}

	if (addr.address_line_1) {
		return addr.address_line_1;
	}

	if (Array.isArray(addr.displayLines) && addr.displayLines.length) {
		return addr.displayLines.filter(Boolean).join(', ');
	}

	return '';
}

export function formatAddressTitle(addr) {
	if (!addr) return '';
	return addr.name || formatAddressLabel(addr);
}

export function formatAddressSubtitle(addr) {
	if (!addr?.name) return '';
	return formatAddressLabel(addr);
}
